import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { ItemType } from "sprout-graphql";
import { Box } from "sprout-ui-primitives";
import { usePostPageEditor } from "../PostPageEditorContext";
import { PostPageTodoEditor } from "../PostPageEditors";
import { PostPageTodoListTodosIncomplete, PostPageTodoListTodosCompleted } from "../PostPageTodoList";
const PostPageTodosOrphanTodos = (props)=>{
    const { disabled , postId , postNodeId , todos , todoSupportedActions , todoSingularAction ,  } = props;
    const incompleteTodos = useMemo(()=>{
        return todos.filter((x)=>!x.completed && !(x.archivedAt && x.deletedAt));
    }, [
        todos
    ]);
    const completedTodos = useMemo(()=>{
        return todos.filter((x)=>x.completed && !(x.archivedAt && x.deletedAt)).sort((a, b)=>{
            return new Date(b.completedAt).getTime() - new Date(a.completedAt).getTime();
        });
    }, [
        todos
    ]);
    const { state  } = usePostPageEditor();
    /**
   * Note: `MAX_SAFE_INTEGER` is used to create orphan todos, and
   * `MIN_SAFE_INTEGER` is used to create `TodoList` todos.
   */ const openTodoNewEditor = state.editor === "CREATE_TODO" && state.editorPosition === Number.MAX_SAFE_INTEGER;
    return /*#__PURE__*/ _jsxs(Box, {
        /**
       * Use padding here, so that the space is accounted by `rb-dnd` to prevent
       * the jitter effect.
       */ pb: 5,
        children: [
            /*#__PURE__*/ _jsx(PostPageTodoListTodosIncomplete, {
                postId: postId,
                parentId: postId,
                parentNodeId: postNodeId,
                parentType: ItemType.Post,
                disabled: disabled,
                todos: incompleteTodos,
                todoSingularAction: todoSingularAction,
                todoSupportedActions: todoSupportedActions
            }),
            /*#__PURE__*/ _jsx(PostPageTodoEditor, {
                topicId: postId,
                parentId: postId,
                parentNodeId: postNodeId,
                parentType: ItemType.Post,
                open: openTodoNewEditor ? state.variant : undefined
            }),
            /*#__PURE__*/ _jsx(PostPageTodoListTodosCompleted, {
                parentId: postId,
                disabled: disabled,
                todos: completedTodos,
                todoSingularAction: todoSingularAction,
                todoSupportedActions: todoSupportedActions
            })
        ]
    });
};
export default PostPageTodosOrphanTodos;
